import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const SiteFooter = {
  instances: new Map(),

  init() {
    document.querySelectorAll('[data-site-footer-watermark]').forEach(watermark => {
      if (this.instances.has(watermark)) return

      const media = gsap.matchMedia()
      this.instances.set(watermark, media)
      media.add('(prefers-reduced-motion: no-preference)', () => this.createWatermark(watermark))
    })
  },

  createWatermark(watermark) {
    const letters = Array.from(watermark.querySelectorAll('mask path')).sort((first, second) => first.getBBox().x - second.getBBox().x)
    if (!letters.length) return

    const animation = gsap.fromTo(
      letters,
      { opacity: 0, yPercent: 100 },
      {
        opacity: 1,
        yPercent: 0,
        duration: 0.8,
        stagger: 0.08,
        ease: 'power2.out',
        clearProps: 'opacity,transform',
        scrollTrigger: {
          trigger: watermark,
          start: 'top 90%',
          end: 'bottom bottom',
          scrub: 2
        }
      }
    )

    return () => {
      animation.scrollTrigger?.kill()
      animation.revert()
    }
  },

  destroy() {
    this.instances.forEach(media => media.revert())
    this.instances.clear()
  }
}

export default SiteFooter
